import { useEffect, useState } from 'react'

export const useElementsOverlap = (element1: HTMLElement | null, element2: HTMLElement | null) => {
    const [isOverlapping, setIsOverlapping] = useState(false)

    useEffect(() => {
        if (!element1 || !element2) return

        const checkElementsOverlap = () => {
            const element1Rect = element1?.getBoundingClientRect()
            const element2Rect = element2?.getBoundingClientRect()

            if (!element1Rect || !element2Rect) return

            // Check if the top of the content is at or above the bottom of the header
            const isOverlapping = element2Rect.top <= element1Rect.bottom

            setIsOverlapping(isOverlapping)
        }

        // Check immediately on mount
        checkElementsOverlap()

        // Check on scroll
        window.addEventListener('scroll', checkElementsOverlap, { passive: true })

        // Also check on resize as element positions might change
        window.addEventListener('resize', checkElementsOverlap, { passive: true })

        return () => {
            window.removeEventListener('scroll', checkElementsOverlap)
            window.removeEventListener('resize', checkElementsOverlap)
        }
    }, [element1, element2])

    return { isOverlapping }
}
